import { getMicroAppPathAfterBase } from 'components/apps/fullscreen/microApp/utils'
import { environment } from 'environment'

interface Params {
  stableId: string
  currentBaseUrl: string
  bundleUrl: string
  libraryType: string
  container: HTMLElement
}

export const createIframeElement = ({
  stableId,
  currentBaseUrl,
  bundleUrl,
  libraryType,
  container,
}: Params): HTMLIFrameElement => {
  const encodedBundleUrl = encodeURIComponent(bundleUrl)
  const initialPath = getMicroAppPathAfterBase(currentBaseUrl)
  const encodedInitialPath = initialPath === '/' ? '/' : encodeURIComponent(initialPath)

  const IFRAME_APP_LAUNCHER_URL = `https://${stableId}.apps.${environment.ENV_BASE_URL}`

  const iframe = document.createElement('iframe')
  iframe.id = stableId
  iframe.style.cssText = 'width: 100%; flex-grow: 1; border: none;'
  iframe.allow = 'clipboard-write'

  iframe.src = `${IFRAME_APP_LAUNCHER_URL}?bundleUrl=${encodedBundleUrl}&initialPath=${encodedInitialPath}&libraryType=${libraryType}`

  container.appendChild(iframe)

  return iframe
}
